module.exports = __webpack_public_path__ + "img/currywurst.10cbc425.png";